export default{
    newsTwoTitle: '金融科技还是金融“科举”？带你一篇看完印尼最新监管细节',
    newsTwoTime: "发布时间",
    newsTwoRead:"阅读量",
    newsTwoSource:"文章来源：",
    newsTwoDetail:[
        {
            h4:"导读"
        },
        {
            p:"印尼央行（BI）在2017年年底对外公布了针对金融科技行业（Fintech）最新的监管框架。据说是要在进一步鼓励本土的金融创新，但同时又要保护好用户的信息和金融的稳定，这矛盾怎么破？"
        },
        {
            h4:"正文"
        },
        {
            p:"现金贷，区块链，电子支付，各种各样野蛮生长的赛道让印尼央行感到了相当大的压力，再不出台监管，金融体系就是“药丸”的节奏。不过，需要理清的一点是，印尼政府并没有说这些赛道的玩家们违反了什么法律法规要明令禁止，反而是当地监管机构，包括金管局（OJK）和央行（BI）老的监管框架都无法覆盖现在的新玩法，为什么现在很多印尼现金贷企业也要跟一些大的借贷平台竞争，尝试去申请P2P借贷的牌照，其中一个原因就是，除了针对P2P的一些简单框架，OJK还没有其他拿得出手的好手段，官方仍然处于慢半拍的节奏上。"
        },
        {
            p:"既然明确的法律框架跟不上金融科技的发展，印尼政府决定用“小心观察”代替“明令禁止”。最新的指导意见包括：No. 19/12/PBI 2017和No. 19/12/PADG/2017，组成部分主要包括下面3个部分，接下来我们逐个细聊金融科技是怎么变成金融 “科举” 的？"
        },
        {
            p:"一. 监管范围"
        },
        {
            p:"科举考试分文武，而金融科技则可以分为6大领域："
        },
        {
            p:"1. 支付系统开发（包括区块链、分布式账本）"
        },
        {
            p:"2. 聚合支付"
        },
        {
            p:"3. 互联网投资管理和风控"
        },
        {
            p:"4. 互联网保险"
        },
        {
            p:"5. 信贷，融资业务和资金配置"
        },
        {
            p:"6. 其他金融服务（由央行判断）"
        },
        {
            p:"上面提到的都属于有资格进入“沙盒“的领域，但是同时必须要满足下面的几个要求，不过这些要求实在有些模糊，于是我们在括号里做进一步的解释："
        },
        {
            p:"i. 属于技术创新的发展（内心独白：纯传统金融的就不要掺乎进来了）"
        },
        {
            p:"ii. 有打破或影响现存金融产品的潜力（内心独白：打破和影响必须是“正面的“，心术要正）"
        },
        {
            p:"iii. 给顾客带来好处（内心独白：更便利？更安全？更效率？更便宜？考生的抱负最好要利国利民）"
        },
        {
            p:"iv. 大范围适用的产品（内心独白：最好是能惠及多数人，而不只小范围才适用，考生要胸怀大志）"
        },

        {
            p:"v. 其他要求（由印尼央行说了算）"
        },
        {
            p:"二. 监管沙盒的运用"
        },
        {
            p:"监管沙盒的推出就是要让金融科技从业者在一个规定的期限内测试上面提到的某种创新金融产品。这么做的原因就是想让玩家们撒开脚丫子，不要畏首畏尾。只要是提前申报了可能的违规行为，而且合规推进该产品实验，都不会被秋后算账。毕竟国家也不想一些对自身有利的创新从指间溜走，于是就用试点的方式来进行。"
        },
        {
            p:"如果“沙盒”的期限到了，央行就会对这个过程进行总结，再决定是否颁发许可证，如果没有得到认可，这个刚走出“沙盒”的产品就无法走进民间，只能宣布夭折。"
        },
        {
            p:"三. 在央行登记的细节和惩罚机制"
        },
        {
            p:"央行在最新的Reg 19/12 2017条例中规定，除了已经拿到了牌照或者归其他监管机构（如OJK）管的企业外，其他所有金融科技企业在2017年12月30日后都要陆续到央行注册，那么注册的程序都是怎样的？我们下面仔细看看："
        },
        {
            p:"i. 登记步骤(PADG 19/15/2017)"
        },
        {
            p:"上印尼央行的官网或者线下人工登记，表格直接用PADG 19/15/2017条例里面的附录1的规定格式，而语言必须是印尼语Bahasa。除了登记表格的之外，同时要上交以下的文件："
        },
        {
            p:"· 公司官方注册证明的复印件"
        },
        {
            p:"· 股权结构"
        },
        {
            p:"· 管理层的姓名"
        },
        {
            p:"· 公司的概况"
        },
        {
            p:"· 和公司金融科技产品/服务/技术和商业模式的介绍"
        },
        {
            p:"· 与金融科技相关的其他信息"
        },
        {
            p:"ii. 已登记企业的公布或罢免"
        },
        {
            p:"印尼央行将会对上面的文件进行考核，通过的企业名单将会被公布在央行的官网上。但是跟考科举一样，过了童试乡试还有会试和殿试，已经注册了的企业如果遇到下面的情况，就有可能会被罢免："
        },
        {
            p:"· 被央行，金管局（OJK）或其他机构惩罚了"
        },
        {
            p:"· 犯了法或者破了产"
        },
        {
            p:"· 监管机构书面提出要取消其资格"
        },
        {
            p:"· 该机构自己提出要取消注册"
        },
        {
            p:"iii. 支付机构上交信息的步骤"
        },
        {
            p:"就像上面提到的，如果已经拿到了牌照的金融科技企业是不需要再注册的，但是，这类企业还是要上交3-i里提到的所有材料和文件，这些企业大多数都是支付机构，因为目前金融科技的正式牌照，基本就是那27个电子支付牌照。"
        },
        {
            p:"iv. 监管的方式"
        },
        {
            p:"进入了注册的名单后，金融科技企业需要按要求提供业务信息，包括涉及金融科技的交易记录（每月一次），产品/服务/技术和商业模式的更新，企业的财政状况和管理层信息（每年一次，或者是任何改变发生后的10天之内）。"
        },
        {
            p:"前面一大堆监管方案，最后当然就是到惩罚机制了。印尼央行对没有满足监管要求的公司做出惩罚，可能包括：书面警告，罢免运营资格。而如果某家公司归OJK或其他部门管的话，除了上面提到的惩罚之外，还有可能面临收回牌照和罚款。"
        },
        {
            p:"小结"
        },
        {
            p:"按照常识来看，“创新”碰上“稳定”，多数时候都是两个矛盾的存在，于是印尼政府决定学习英国和新加坡，把“沙盒”搬上了台面，鼓励金融企业在一个可控的情况之下进行创新，一来不会怠慢了金融科技的发展，二来也不会造成社会的不稳定。然而，要进入当地央行设置繁琐的“沙盒”相当不容易，包括了上面介绍的冗长注册手续和监管流程，这真是检验一个企业自身过不过硬最好的测验，想进入体制内还真跟考科举一样，真他喵的难！"
        },
        {
            p:"以上就是为关注东南亚金融市场法规的人士精心准备的，主要是针对印尼央行在2017年12月底推出的最新监管条例”Reg 19/12/2017”的分析。金融科技企业们在出海和落地前请做好这些准备。"
        },
        

    ]
}